import { useEffect, useState } from "react";
import ProtectedRoutes from "../routes/ProtectedRoutes";
import { Skeleton } from "@mui/material";

interface AuthWrapperProps {
  isGroupMember: boolean | null;
  apiToken: string | null;
  accessApi: () => Promise<void>;
}

const AuthWrapper = ({ isGroupMember, apiToken, accessApi }: AuthWrapperProps) => {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    // Wait until isGroupMember is no longer undefined/null
    if (typeof isGroupMember === "boolean") {
      setIsAuthReady(true);
    }
  }, [isGroupMember]);

  return (
    <>
      {
        isAuthReady ?
          <ProtectedRoutes
            isGroupMember={isGroupMember}
            apiToken={apiToken}
            accessApi={accessApi}
          />
          :
          <Skeleton height={800} />
      }
    </>
  );
};

export default AuthWrapper;
